module.exports = __webpack_public_path__ + "img/20220107_103958 (1).6ddc1eaf.jpg";